import { render, staticRenderFns } from "./SidebarCustom.vue?vue&type=template&id=a4d286aa&"
import script from "./SidebarCustom.vue?vue&type=script&lang=js&"
export * from "./SidebarCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports